import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Splitter/SplitterUsage.mdx";

import Examples from "../../Docs/Components/Splitter/SplitterExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Splitter"
            description="The splitter component adds a visual vertical or horizontal divider between two blocks of content."
            apiSources={["azure-devops-ui/Components/Splitter/Splitter.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;